<template>
  <div v-for="day in Object.keys(shiftsByDay)" :key="day">
    <slot name="day-label" :label="day" />
    <checkboxes-input :value="valueForDay(day)"
                      :display-in-columns="false"
                      :options="shiftOptionsForDay(day)"
                      @changed="(shifts) => updateDayShifts(day, shifts)" />
  </div>
</template>

<script>
import CheckboxesInput from '@/components/inputs/checkboxes-input'

export default {
  components: { CheckboxesInput },

  props: {
    initialSelectedShiftIds: {
      type: Array,
      required: true
    },

    shiftsByDay: {
      type: Object,
      required: true
    }
  },

  emits: ['changed'],

  data() {
    let selectedShiftIdsByDay = {}
    for (const [day, shifts] of Object.entries(this.shiftsByDay)) {
      selectedShiftIdsByDay[day] = shifts.filter(
        (shift) => this.initialSelectedShiftIds.includes(shift.id)
      ).map((shift) => shift.id)
    }

    return {
      selectedShiftIdsByDay
    }
  },

  computed: {
    selectedShiftIds() {
      return Object.values(this.selectedShiftIdsByDay).reduce((prev, cur) => prev.concat(cur))
    }
  },

  watch: {
    shiftsByDay() {
      // De-select any shifts that are no longer open, unless they were in our initial selections
      for (const [day, shifts] of Object.entries(this.shiftsByDay)) {
        const updatedShiftIds = this.valueForDay(day).filter((selectedShiftId) => {
          const shift = shifts.find((shift) => shift.id === selectedShiftId)
          return shift.open || this.initialSelectedShiftIds.includes(selectedShiftId)
        })
        if (updatedShiftIds.length < this.valueForDay(day).length) {
          this.updateDayShifts(day, updatedShiftIds)
        }
      }
    }
  },

  methods: {
    shiftOptionsForDay(day) {
      const component = this
      return this.shiftsByDay[day].map(function(s) {
        // Always disable the checkbox for shifts on past days.
        // Disable the checkbox for full shifts, _unless_ the user has already signed up for that shift,
        // because we want to allow them to change their shifts.
        const disabled = s.past || (!s.open && !component.initialSelectedShiftIds.includes(s.id))

        return [s.label, s.id, disabled]
      })
    },

    updateDayShifts(day, shifts) {
      this.selectedShiftIdsByDay[day] = shifts
      this.$emit('changed', this.selectedShiftIds)
    },

    valueForDay(day) {
      return this.selectedShiftIdsByDay[day] || []
    }
  }
}
</script>
